import SkeletonLoader from './index';

const TeachersGridSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <div
          key={i}
          className="border border-neutral-light-200 rounded-2xl p-4 space-y-4 bg-white"
        >
          <div className="flex items-center gap-4">
            <SkeletonLoader variant="circle" width={40} height={40} />
            <SkeletonLoader width={150} height={28} />
          </div>

          <div className="flex gap-2">
            <SkeletonLoader width={16} height={16} />
            <div className="flex flex-col gap-1 w-full">
              <SkeletonLoader width={100} height={12} />
              <SkeletonLoader width={180} height={16} />
            </div>
          </div>

          <div className="flex gap-2">
            <SkeletonLoader width={16} height={16} />
            <div className="flex flex-col gap-1 w-full">
              <SkeletonLoader width={120} height={12} />
              <SkeletonLoader width={40} height={20} className="rounded-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeachersGridSkeleton;
